export function generateKubernetesCommand (device: string, unryoToken: string, vaultToken: string) {
  if (device === 'collector') {
    return `helm install --create-namespace --namespace unryo my-release --set "profile=collector,config.secret.unryoToken=${unryoToken}" https://downloads.unryo.com/helms-unryo-latest.tgz`
  }

  return `helm install --create-namespace --namespace unryo my-release --set "config.secret.unryoToken=${unryoToken},config.secret.unryoVaultToken=${vaultToken}" https://downloads.unryo.com/helms-unryo-latest.tgz`
}
